// extracted by mini-css-extract-plugin
module.exports = {"VerticalNavigationitem":"VerticalNavigationitem_VerticalNavigationitem__2ShQd","VerticalNavigationitemSub":"VerticalNavigationitem_VerticalNavigationitemSub__EeeKL"};